import { FC, Suspense, lazy } from "react"
import { useAppSelector } from "store/index"
import { AppSelectors } from "store/slices/appSlice"

const SnowfallContent = lazy(() => import("./ui/SnowfallV2Content"))

export const SnowfallV2: FC = () => {
  const theme = useAppSelector(AppSelectors.selectTheme())

  if (theme !== "winter") return null

  return (
    <Suspense fallback={null}>
      <SnowfallContent />
    </Suspense>
  )
}
